export default "/images/b4c3f64e6cf0e2d04561c44095cc0351.avif";